// SoundBox
import React from 'react';
import Sound from 'react-sound';
import { connect } from 'react-redux';

import { soundPlayed } from '../redux/actions/chatInitAction';

@connect((Store) => {
  return {
    sound: Store.chat.soundToPlay,
    soundSetting: Store.settings.sound
  }
})

export default class SoundBox extends React.Component {
  handleSongFinishedPlaying() {
    this.props.dispatch(soundPlayed());
  }

  render() {
    const type = this.props.sound ? '../audio/'+this.props.sound+'.mp3' : '';

    if (!type || this.props.soundSetting == 'off') {
      return <div className='no-sound'></div>
    }

    return (
      <Sound
        url={type}
        playStatus={Sound.status.PLAYING}
        onFinishedPlaying={this.handleSongFinishedPlaying.bind(this)}
      />
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/SoundBox.jsx